import { tenantApi } from '@vmos2/core';
import qs from 'qs';

export const useBrandsThemes = () => {
  const fetchBrandsThemes = async (brands: { uuid: string }[]) => {
    try {
      const response = await tenantApi.get('themes', {
        params: { brands },
        paramsSerializer: (params: Record<string, string>) => {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        },
        skipAuth: true,
      });

      return response;
    } catch (error) {
      console.log('error: ', error);

      return {};
    }
  };

  return { fetchBrandsThemes };
};
